module.exports = __webpack_public_path__ + "img/s-l1600 (1).3a1b0dea.jpg";